import { ThemeTokens, VARIANTS } from '../../types';
import {
    ACCESSIBLE_BRAND_ORANGE,
    BLACK,
    BRAND_PURPLE,
    styles as coreStyles,
    TRANSPARENT,
    WHITE,
} from './core-theme';

const MELLOW_BLUE = '#324B8C';
const MELLOW_YELLOW = '#FFE6BE';
const MELLOW_PINK = '#FAAFA0';

const styles: Record<VARIANTS, Record<ThemeTokens, any>> = {
    ...coreStyles,
    mood_01: {
        background: {
            background: MELLOW_YELLOW,
        },
        'overlay-gradient': {
            color: WHITE,
            background: MELLOW_YELLOW,
        },
        ctaLink: {
            border: MELLOW_BLUE,
            color: BRAND_PURPLE,
        },
        'card-ctaLink': {
            border: ACCESSIBLE_BRAND_ORANGE,
            color: BRAND_PURPLE,
        },
        'card-text': {
            color: BRAND_PURPLE,
            underline: ACCESSIBLE_BRAND_ORANGE,
        },
        text: {
            color: BRAND_PURPLE,
            underline: MELLOW_BLUE,
        },
        card: {
            background: WHITE,
        },
        'button-primary': {
            background: MELLOW_BLUE,
            color: WHITE,
            fill: WHITE,
            border: `2px solid ${TRANSPARENT}`,
            hover: {
                background: MELLOW_BLUE,
            },
            focus: {
                background: MELLOW_BLUE,
            },
            active: {
                background: MELLOW_BLUE,
            },
        },
        'button-secondary': {
            background: TRANSPARENT,
            color: BRAND_PURPLE,
            fill: BRAND_PURPLE,
            border: `2px solid ${BRAND_PURPLE}`,
            hover: {
                background: TRANSPARENT,
            },
            focus: {
                background: TRANSPARENT,
            },
            active: {
                background: TRANSPARENT,
            },
        },
        'expansion-panel-content':
            coreStyles.core_light['expansion-panel-content'],
        'expansion-panel-heading':
            coreStyles.core_light['expansion-panel-heading'],
        'expansion-panel-trigger':
            coreStyles.core_light['expansion-panel-trigger'],
        divider: coreStyles.core_light.divider,
        'text-v2': coreStyles.core_light['text-v2'],
        'background-v2': coreStyles.core_light['background-v2'],
    },
    mood_02: {
        background: {
            background: MELLOW_PINK,
        },
        'overlay-gradient': {
            color: WHITE,
            background: MELLOW_PINK,
        },
        ctaLink: {
            border: MELLOW_BLUE,
            color: BRAND_PURPLE,
        },
        'card-ctaLink': {
            border: ACCESSIBLE_BRAND_ORANGE,
            color: BRAND_PURPLE,
        },
        'card-text': {
            color: BRAND_PURPLE,
            underline: ACCESSIBLE_BRAND_ORANGE,
        },
        text: {
            color: BRAND_PURPLE,
            underline: MELLOW_BLUE,
        },
        card: {
            background: WHITE,
        },
        'button-primary': {
            background: MELLOW_BLUE,
            color: WHITE,
            fill: WHITE,
            border: `2px solid ${TRANSPARENT}`,
            hover: {
                background: MELLOW_BLUE,
            },
            focus: {
                background: MELLOW_BLUE,
            },
            active: {
                background: MELLOW_BLUE,
            },
        },
        'button-secondary': {
            background: TRANSPARENT,
            color: BRAND_PURPLE,
            fill: BRAND_PURPLE,
            border: `2px solid ${BRAND_PURPLE}`,
            hover: {
                background: TRANSPARENT,
            },
            focus: {
                background: TRANSPARENT,
            },
            active: {
                background: TRANSPARENT,
            },
        },
        'expansion-panel-content':
            coreStyles.core_light['expansion-panel-content'],
        'expansion-panel-heading':
            coreStyles.core_light['expansion-panel-heading'],
        'expansion-panel-trigger':
            coreStyles.core_light['expansion-panel-trigger'],
        divider: coreStyles.core_light.divider,
        'text-v2': coreStyles.core_light['text-v2'],
        'background-v2': coreStyles.core_light['background-v2'],
    },
    mood_03: {
        background: {
            background: MELLOW_BLUE,
        },
        'overlay-gradient': {
            color: BLACK,
            background: MELLOW_BLUE,
        },
        ctaLink: {
            border: MELLOW_PINK,
            color: WHITE,
        },
        'card-ctaLink': {
            border: ACCESSIBLE_BRAND_ORANGE,
            color: BRAND_PURPLE,
        },
        'card-text': {
            color: BRAND_PURPLE,
            underline: ACCESSIBLE_BRAND_ORANGE,
        },
        text: {
            color: WHITE,
            underline: MELLOW_PINK,
        },
        card: {
            background: WHITE,
        },
        'button-primary': {
            background: MELLOW_PINK,
            color: BRAND_PURPLE,
            fill: BRAND_PURPLE,
            border: `2px solid ${TRANSPARENT}`,
            hover: {
                background: MELLOW_PINK,
            },
            focus: {
                background: MELLOW_PINK,
            },
            active: {
                background: MELLOW_PINK,
            },
        },
        'button-secondary': {
            background: TRANSPARENT,
            color: WHITE,
            fill: WHITE,
            border: `2px solid ${WHITE}`,
            hover: {
                background: TRANSPARENT,
            },
            focus: {
                background: TRANSPARENT,
            },
            active: {
                background: TRANSPARENT,
            },
        },
        'expansion-panel-content':
            coreStyles.core_light['expansion-panel-content'],
        'expansion-panel-heading':
            coreStyles.core_light['expansion-panel-heading'],
        'expansion-panel-trigger':
            coreStyles.core_light['expansion-panel-trigger'],
        divider: coreStyles.core_light.divider,
        'text-v2': coreStyles.core_light['text-v2'],
        'background-v2': coreStyles.core_light['background-v2'],
    },
};

export const getThemeTokens = (token: ThemeTokens, variant: VARIANTS) => {
    return styles[variant][token];
};
